// eslint-disable-next-line
// @ts-ignore
import { TheiaStickySidebar } from "theia-sticky-sidebar/dist/theia-sticky-sidebar.es";

document.addEventListener('DOMContentLoaded', function () {
  new TheiaStickySidebar({
      elements: '.main_side__left, .main_side__right',
      containerSelector: "#main",
      additionalMarginTop: 100,
      defaultPosition: "absolute"
  });
});